import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class GroupATemplateService {

  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  constructor(private http: HttpClient) { }

  /**
    * Método encargado de cargar examen
    * @param request
    * @param baseUrl
    * @returns
    */
  loadExam(request: any, baseUrl: string): Observable<any> {
    request = this.addSessionFields(request);
    return this.http.post<any>(this.buildUrlApi(baseUrl), request);
  }


  /**
   * Método encargado de agregar a los request los campos comunes correspondientes al usuario logueado
   * @param request
   * @returns
   */
  private addSessionFields(request: any): any {
    request.modelId = this.currentUser.modelId;
    request.userId = this.currentUser.userId;
    request.prestadorCod = this.currentUser.prestadorCod;
    return request;
  }

  /**
   * Método encargado de construir la URL del end-point para cargar examenes
   * @param method
   * @returns
   */
  buildUrlApi(method: string): string {
    return `${environment.apiUrl}` + method;
  }
}


